export const RESULT_OPTIONS = {
  PASSED: {display: 'Passed', value: 'Passed', showOrder: 1, def: false},
  FAILED: {display: 'Failed', value: 'Failed', showOrder: 0, def: false},
};
